export class CheckProvinceSelectorModel {
    value: string;
}
